import { render, staticRenderFns } from "./ItemSettingsBulk.vue?vue&type=template&id=385347f7&"
import script from "./ItemSettingsBulk.vue?vue&type=script&lang=js&"
export * from "./ItemSettingsBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports